import isValueEmpty from '../../isValueEmpty';

export const errorMessage = __('Must be a number');

export const validateNumberFormat = (value) => {
  let error;

  if (isValueEmpty(value)) {
    return error;
  }

  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value) || Array.isArray(value)) {
    error = errorMessage;
  }

  return error;
};
